import Promise from 'bluebird';
import { completePageLoad } from 'common/page/actions';
import { scoreScheduleModule } from 'common/scheduleModule/actions';

export function scoreAll() { // eslint-disable-line
    return (dispatch) => Promise.all([
        dispatch(completePageLoad()),
        dispatch(scoreScheduleModule())
    ]);
}



// WEBPACK FOOTER //
// ./app/common/actions/scoringActions.js